export default __webpack_public_path__ + "1de52adbada3bfb243437b04fbcf1d11.png";